const isIOS = (): boolean => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(userAgent);
    const iPad13 = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return ios || iPad13;
  };
  export default isIOS;